// Footer component for NAMHS appointment website
import React from 'react';

// Footer component for NAMHS appointment website
// relates to the bottom of the page informations like location, contact, etc.
function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-8 relative" style={{ marginTop: '-1px' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* HIPAA Compliance Badge - Top Left 
            TODO: RE-ENABLE AFTER ACHIEVING HIPAA COMPLIANCE
            Temporarily hidden while working on HIPAA compliance certification.
            To re-enable: uncomment the div below
        */}
        {/* <div className="mb-6">
          <img 
            src="/assets/Footer/hipaa-blue.png" 
            alt="HIPAA Compliant" 
            className="h-16 w-auto"
          />
        </div> */}
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">North American Mental Health Services</h3>
            <p className="text-gray-400">
              Providing compassionate mental health care across California.
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#locations" className="text-gray-400 hover:text-white">
                  Locations
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-white">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2 text-gray-400">
              <li>Phone: (888) 292 - 8080</li>
              <li>Fax: (530) 722 - 4544</li>
              <li>Email: appointment@namhs.com</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} North American Mental Health Services. All rights reserved.</p>
          <p className="text-xs text-gray-600 mt-2">Pegasus v1.5.3</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 